/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { redSmsCallbackRequestSchema } from "./redSmsCallbackRequestSchema.ts";
import { redSmsCallbackSchema } from "./redSmsCallbackSchema.ts";

export const userSmsCallbackRedsmsCreateStatus200Schema = redSmsCallbackSchema.describe("Сериализатор обработки коллбэка от RedSMS.");

export const userSmsCallbackRedsmsCreateResponseSchema = userSmsCallbackRedsmsCreateStatus200Schema;

export const userSmsCallbackRedsmsCreateDataSchema = redSmsCallbackRequestSchema.describe("Сериализатор обработки коллбэка от RedSMS.");
